import React, {Component} from 'react';
import {Modal, Button} from 'antd';

class AlertConfigurationServiceMsgConfirm extends Component {

    state = {
        loading: false,
        visible: false,
    }

    showModal = () => {
        this.setState({
            loading: false,
            visible: true,
        });
    }

    handleOk = (e) => {
        this.props.handleSubmit(e);
        this.setState({
            loading: false,
            visible: false
        });
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    createCustomToolBar = props => {
        return (
            <div>
                <div className='searchFiled'>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    render() {
        const { visible, loading } = this.state;

        return (
            <div>
                <Button onClick={this.showModal} className="btn-save ant-btn-primary" title="Save">
                    <i title="Save"></i>Save
                </Button>
                <Modal visible={visible} title='Platform Alert Confirm' onOk={this.handleOk}
                       onCancel={this.handleCancel} maskClosable={false}
                       footer={[
                           <Button key="submit" type="primary" size="large" loading={loading} onClick={this.handleOk}>Save</Button>,
                           <Button key="back" size="large" onClick={this.handleCancel}>Cancel</Button>,
                       ]}>
                    <div style={{margin: 20}}>
                        Are you sure commit this configuration?
                    </div>
                </Modal>
            </div>
        );
    }
}
export default AlertConfigurationServiceMsgConfirm;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/AlertConfigurationServiceMsgConfirm.js